module.exports = __webpack_public_path__ + "img/empty.3c522ea9.svg";